import React from 'react';
import { Navigate } from 'react-router-dom';

import { useSelector } from '../../redux/hooks';
import { selectUserProfile } from '../../redux/actions/users';

type PropsType = {
    children: React.ReactNode
};

export default function Admin({ children }: PropsType) {
    const userProfile = useSelector(selectUserProfile());

    if (userProfile?.isAdmin === false) {
        return <Navigate to="/" replace />;
    }

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{ children }</>;
}
